export default __webpack_public_path__ + "68b365e2fe87351552fd144c43d5e258.png";